import React from 'react';
import styled from 'styled-components';
import I18nMessage from '../I18nMessage';

export const MapStatus = styled.div`
      width: 14px;
      height: 14px;
      border-radius: 50%;
      flex-shrink: 0;
`;

const LegendItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    margin: 0 6px;
`;

const TextInfo = styled.span`
    color: black;
    font-size: 0.6rem;
    white-space: nowrap;
`;

const MapStatusGreen = styled(MapStatus)`
  background-color: #008B00;
`;

const MapStatusRed= styled(MapStatus)`
  background-color: #CE3834;
`;

const MapStatusGray = styled(MapStatus)`
  background-color: #9CA8B4;
`;

const MapStatusYellow = styled(MapStatus)`
  background-color: #FEA100;
`;

const MapStatusBlue = styled(MapStatus)`
  background-color: #356DD5;
`;


export const LegendContainer = styled.div`
      position: absolute;
      bottom: 25px;
      right: 0;
      padding: 10px;
      padding-right: 35px;
      z-index: 900;
      display: flex;
      flex-direction: row;
      align-items: center;
`;

const MapLegend = () => {
    return <LegendContainer>
        <LegendItem><MapStatusGray /><TextInfo><I18nMessage id="deviceStatusOffline" /></TextInfo></LegendItem>
        <LegendItem><MapStatusRed /><TextInfo><I18nMessage id="positionAlarm" /></TextInfo></LegendItem>
        <LegendItem><MapStatusYellow /><TextInfo><I18nMessage id="deviceStatusUnknown" /></TextInfo></LegendItem>
        <LegendItem><MapStatusBlue /><TextInfo><I18nMessage id="legendDeviceOn" /></TextInfo></LegendItem>
        <LegendItem><MapStatusGreen /><TextInfo><I18nMessage id="deviceStatusOnline" /></TextInfo></LegendItem>
    </LegendContainer>;
};

export default MapLegend;
